import * as React from "react";
import { ProductImageGallery } from "./detailCarousel/ProductImageGallery";
import { ProductImageZoomModal } from "./detailCarousel/ProductImageZoomModal";
import { buildImageAlt } from "./detailCarousel/galleryUtils";
import type { DetailCarouselProps, ProductGalleryImage } from "./detailCarousel/types";

export type { DetailCarouselProps, ProductGalleryImage } from "./detailCarousel/types";

const DetailCarousel = ({
  images = [],
  isNarrowViewport,
  indexImg,
  onChangeIndex,
  imageAltPrefix,
}: DetailCarouselProps) => {
  const [zoomOpen, setZoomOpen] = React.useState(false);
  const total = images.length;

  const getAlt = React.useCallback(
    (i: number) => buildImageAlt(imageAltPrefix, i, total),
    [imageAltPrefix, total],
  );

  const arrowIconSize = isNarrowViewport ? 30 : 40;

  const zoomA11yTitle =
    (imageAltPrefix?.trim() && `${imageAltPrefix.trim()} — zoomed view`) ||
    "Product image — zoomed view";

  return (
    <>
      <ProductImageGallery
        variant="page"
        images={images}
        indexImg={indexImg}
        onChangeIndex={onChangeIndex}
        getAlt={getAlt}
        arrowIconSize={arrowIconSize}
        onRequestZoom={() => setZoomOpen(true)}
      />
      <ProductImageZoomModal
        open={zoomOpen}
        onClose={() => setZoomOpen(false)}
        a11yTitle={zoomA11yTitle}>
        <ProductImageGallery
          variant="modal"
          images={images}
          indexImg={indexImg}
          onChangeIndex={onChangeIndex}
          getAlt={getAlt}
          arrowIconSize={arrowIconSize}
        />
      </ProductImageZoomModal>
    </>
  );
};

export default DetailCarousel;
